import { useState, useEffect } from "react";
import { Modal } from "react-bootstrap";
import { useTranslation } from "react-i18next";
import Button from "../../shared/Button";
import { Icon } from "../../shared";
import { useSelector } from "react-redux";
import "./index.css";

const AppDisclaimer = () => {
  const { t } = useTranslation();
  const content = useSelector((state) => state.content);

  const [show, setShow] = useState(false);

  useEffect(() => {
    if (!content.settings?.showDisclaimer) return;

    // Check if user has already acknowledged the disclaimer notice
    const hasAcknowledged = localStorage.getItem("disclaimerNoticeAcknowledged");

    if (!hasAcknowledged) {
      setShow(true);
    }
  }, []);

  const handleAcknowledge = () => {
    // Store acknowledgment in localStorage
    localStorage.setItem("disclaimerNoticeAcknowledged", "true");
    setShow(false);
  };

  return (
    <Modal show={show} backdrop="static" keyboard={false} centered className="disclaimer-modal">
      <Modal.Header className="disclaimer-modal-header">
        <span className="disclaimer-icon">
          <Icon iconName="exclamation" />
        </span>
        <Modal.Title className="disclaimer-modal-title">{t("disclaimerModal.title")}</Modal.Title>
      </Modal.Header>
      <Modal.Body className="disclaimer-modal-body">
        <div className="disclaimer-content">
          <div className="disclaimer-message">
            <p>{t("disclaimerModal.message")}</p>
            <p className="disclaimer-details">{t("disclaimerModal.details")}</p>
            <p className="disclaimer-contact">
              {t("disclaimerModal.contact")}{" "}
              <a href="mailto:aljedpo@alj.com" className="disclaimer-contact-link">
                aljedpo@alj.com
              </a>
            </p>
            <p className="mt-3 mb-0">{t("disclaimerModal.contact2")}</p>
          </div>
        </div>
      </Modal.Body>
      <Modal.Footer className="disclaimer-modal-footer">
        <Button type="small-roundedRight" customize="mx-0" onClick={handleAcknowledge}>
          {t("disclaimerModal.acknowledge")}
        </Button>
      </Modal.Footer>
    </Modal>
  );
};

export default AppDisclaimer;
